"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_OPEN_GRAPH_LOCALES_BY_LANGUAGE = void 0;
exports.DEFAULT_OPEN_GRAPH_LOCALES_BY_LANGUAGE = {
    en: "en_US",
    fr: "fr_CA",
    es: "es_US",
};
